// Who may open a Forge team tool outside the Forge page. Two gates, both required:
// the Forge itself (app Admin or Editor, as AIHub/ForgeHub and ScorecardView.canForge) and
// the tool's own Team Hub rule — keep these in step with ForgeTeam.vue `actions` (ok:).
export function canUseForge(user: any): boolean {
    return !!(user && user.isAdmin && ['Admin', 'Editor'].includes(user.role));
}

export function canUseForgeTool(user: any, kind: string): boolean {
    if (!canUseForge(user)) return false;
    const admin = user.teamHubRole == 'Admin';
    const employee = !!user.teamHubEmployee;
    const manager = !!(user.teamHubEmployee && user.teamHubEmployee.IsManager);
    const locations = (user.locations || []).filter((l: any) => typeof l == 'string');
    switch (kind) {
        case 'scorecard': case 'improvemetrics': case 'skills': case 'event': return admin;
        case 'rocks': case 'milestones': case 'improve': return admin || employee;
        case 'training': return admin || manager;
        case 'announcement': return admin && locations.length > 0;
        default: return false;
    }
}
